import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { showAlert } from '../components/common/GeneralAlert';
import { isDev } from './general';
import { requestUrlToI18nKey } from './helpers';
export const showApiAlert = response => {
  var _response$options;
  if (!response.isErrorHandled && response !== null && response !== void 0 && (_response$options = response.options) !== null && _response$options !== void 0 && _response$options.url) {
    const key = `${response.options.method}${requestUrlToI18nKey(response.options.url)}`;
    const isTitleKeyValid = isValidI18nKey(`errors.${key}ApiError`);
    const isMessageKeyValid = isValidI18nKey(`errors.${key}ApiErrorMessage`);

    // check if we have translation for this key
    if (isTitleKeyValid) {
      showAlert({
        title: `errors.${key}ApiError`,
        message: isMessageKeyValid ? `errors.${key}ApiErrorMessage` : 'errors.generalHubSpotApiErrorDescription',
        id: `error-alert-${key}`
      });
      response.isErrorHandled = true;
    } else if (isDev) {
      console.warn(`missing translation for api error alert, key=${key}ApiError`);
    }
  }
};